"use strict";

exports.__esModule = true;
exports.EDITOR_HOOKS = void 0;
const EDITOR_HOOKS = exports.EDITOR_HOOKS = {
  PP_SETTINGS_TABS: 'settings-tabs',
  PP_SETTINGS_LAYOUT_TAB_BUTTON: 'layout-tab-button',
  PP_SETTINGS_DISPLAY_TAB_BUTTON: 'display-tab-button',
  PP_SETTINGS_DESIGN_TAB_BUTTON: 'design-tab-button',
  PP_SETTINGS_MAIN_TAB: 'main-tab',
  PP_SETTINGS_CONTENT: 'settings-tab-content',
  PP_SETTINGS_ALIGNMENT_LEFT: 'left-alignment',
  PP_SETTINGS_ALIGNMENT_CENTER: 'center-alignment',
  PP_SETTINGS_ALIGNMENT_RIGHT: 'right-alignment',
  PP_SETTINGS_PLANS_CREATE_NEW: 'plans-tab-create-new',
  PP_SETTINGS_PLANS_SORT_LIST: 'plans-tab-sort-list',
  PP_SETTINGS_PLANS_SORT_LIST_EDIT_PLAN: 'plans-tab-sort-list-edit-plan',
  PP_SETTINGS_PLANS_LIMIT_NOTIFICATION: 'plans-tab-limit-notification',
  PP_SETTINGS_DISPLAY_TAB: 'display-tab',
  PP_SETTINGS_DISPLAY_TAB_SHOW_TITLE: 'show-title',
  PP_SETTINGS_DISPLAY_TAB_SHOW_SUBTITLE: 'show-subtitle',
  PP_SETTINGS_DISPLAY_TAB_SHOW_HIGHLIGHTED_PLAN: 'show-highlighted-plan',
  PP_SETTINGS_DISPLAY_TAB_SHOW_RIBBON: 'show-ribbon',
  PP_SETTINGS_DISPLAY_TAB_SHOW_IMAGE: 'plan-image',
  PP_SETTINGS_DESIGN_TAB: 'design-tab',
  PP_SETTINGS_DESIGN_BAB: 'design-backgrounds-and-borders',
  PP_SETTINGS_DESIGN_BAB_TAB: 'design-backgrounds-and-borders-tab',
  PP_SETTINGS_DESIGN_BAB_APP_BACKGROUND_PICKER: 'app-background-picker',
  PP_SETTINGS_DESIGN_BAB_TABS: 'design-backgrounds-and-borders-tabs',
  PP_SETTINGS_DESIGN_BAB_R_TITLE_BACKGROUND_PICKER: 'title-background-picker',
  PP_SETTINGS_DESIGN_BAB_R_BENEFITS_BACKGROUND_PICKER: 'benefits-background-picker',
  PP_SETTINGS_DESIGN_BAB_R_PLAN_BORDER_WIDTH_SLIDER: 'card-border-width-slider',
  PP_SETTINGS_DESIGN_BAB_R_CARD_BORDER_PICKER: 'card-border-picker',
  PP_SETTINGS_DESIGN_BAB_R_SHADOW_TOGGLE: 'card-regular-shadow-toggle',
  PP_SETTINGS_DESIGN_BAB_R_SHADOW_SETTINGS: 'card-regular-shadow-settings',
  PP_SETTINGS_DESIGN_BAB_H_SHADOW_TOGGLE: 'card-highlighted-shadow-toggle',
  PP_SETTINGS_DESIGN_BAB_H_SHADOW_SETTINGS: 'card-highlighted-shadow-settings',
  PP_SETTINGS_DESIGN_BAB_H_BENEFITS_BACKGROUND_PICKER: 'highlighted-plan-benefits-background-picker',
  PP_SETTINGS_DESIGN_BAB_H_TITLE_BACKGROUND_PICKER: 'highlighted-plan-title-background-picker',
  PP_SETTINGS_DESIGN_BAB_RESET_BUTTON: 'reset-background-and-borders-styles',
  PP_SETTINGS_DESIGN_TEXT: 'design-texts',
  PP_SETTINGS_DESIGN_TEXT_TAB: 'design-texts-tab',
  PP_SETTINGS_DESIGN_TEXT_TABS: 'design-texts-tabs',
  PP_SETTINGS_DESIGN_TEXT_HIGHLIGHTED_TAB: 'design-texts-highlighted-tab',
  PP_SETTINGS_DESIGN_TEXT_PAGE_HEADER_PICKER: 'page-header-picker',
  PP_SETTINGS_DESIGN_TEXT_PLAN_TITLE_PICKER: 'plan-title-picker',
  PP_SETTINGS_DESIGN_TEXT_PLAN_PRICE_PICKER: 'plan-price-picker',
  PP_SETTINGS_DESIGN_TEXT_PLAN_TAGLINE_PICKER: 'plan-tagline-picker',
  PP_SETTINGS_DESIGN_TEXT_PLAN_SETUP_FEE_PICKER: 'plan-setup-fee-picker',
  PP_SETTINGS_DESIGN_TEXT_PLAN_BENEFITS_PICKER: 'plan-benefits-picker',
  PP_SETTINGS_DESIGN_TEXT_RESET_BUTTON: 'reset-text-styles',
  PP_SETTINGS_DESIGN_BUTTON: 'design-button',
  PP_SETTINGS_DESIGN_BUTTON_R_STYLE_EMPTY_CORNERED: 'button-style-empty-cornered',
  PP_SETTINGS_DESIGN_BUTTON_R_STYLE_EMPTY_ROUNDED: 'button-style-empty-rounded',
  PP_SETTINGS_DESIGN_BUTTON_R_STYLE_FULL_CORNERED: 'button-style-full-cornered',
  PP_SETTINGS_DESIGN_BUTTON_R_STYLE_FULL_ROUNDED: 'button-style-full-rounded',
  PP_SETTINGS_DESIGN_BUTTON_R_CORNER_RADIUS: 'button-corner-radius',
  PP_SETTINGS_DESIGN_BUTTON_R_BORDER_WIDTH: 'button-border-width',
  PP_SETTINGS_DESIGN_BUTTON_R_BORDER_COLOR: 'button-border-color',
  PP_SETTINGS_DESIGN_RIBBON: 'design-ribbon',
  PP_SETTINGS_DESIGN_RIBBON_TAB: 'design-ribbon-tab',
  PP_SETTINGS_DESIGN_RIBBON_RESET_BUTTON: 'reset-ribbon-styles',
  PP_SETTINGS_LAYOUT_TAB: 'layout-tab',
  PP_SETTINGS_LAYOUT_TAB_PAGE_TEXT_LAYOUT_SECTION_HEADER: 'page-text-layout-section-header',
  PP_SETTINGS_LAYOUT_TAB_TITLE_ALIGNMENT: 'title-alignment',
  PP_SETTINGS_LAYOUT_TAB_SUBTITLE_ALIGNMENT: 'subtitle-alignment',
  PP_SETTINGS_LAYOUT_TAB_DISCLAIMER_ALIGNMENT: 'disclaimer-alignment',
  PP_SETTINGS_LAYOUT_TAB_DESCRIPTION_ALIGNMENT: 'description-alignment',
  PP_SETTINGS_LAYOUT_TAB_BENEFITS_SECTION_HEADER: 'benefitS-section-header',
  PP_SETTINGS_LAYOUT_TAB_BENEFITS_BULLETS: 'benefits-bullets',
  PP_SETTINGS_LAYOUT_TAB_BENEFITS_ARROW_BULLET: 'benefits-arrow-bullet',
  PP_SETTINGS_LAYOUT_TAB_BENEFITS_ALIGNMENT: 'benefits-alignment',
  PP_SETTINGS_LAYOUT_TAB_LINE_SPACING: 'benefits-layout-line-spacing',
  PP_SETTINGS_TEXT_TAB_PAGE_HEADER: 'page-header-text',
  PP_SETTINGS_TEXT_TAB_BUTTON: 'button-text',
  PP_SETTINGS_TEXT_TAB_RIBBON: 'ribbon-text',
  PP_SETTINGS_SUPPORT_TAB: 'support-tab',
  PP_SETTINGS_SUPPORT_ARTICLES: 'support-link-button',
  PP_SETTINGS_SUPPORT_CHATBOT: 'customer-care-link-button',
  PP_MOBILE_SETTINGS_LAYOUT_CARDS_SPACING: 'mobile-cards-spacing',
  PP_MOBILE_SETTINGS_LAYOUT_CARDS_SPACING_SLIDER: 'mobile-cards-spacing-slider',
  PP_MOBILE_SETTINGS_DESIGN_RESET_BUTTON: 'mobile-design-reset-button',
  SETTINGS_WRAPPER: 'settings.wrapper',
  SETTINGS_PLAN_DROPDOWN: 'settings.plan-dropdown',
  LAYOUT_WRAPPER: 'layout.wrapper',
  LAYOUT_VERTICAL: 'layout.vertical',
  LAYOUT_HORIZONTAL: 'layout.horizontal',
  LAYOUT_IMAGE_HEIGHT: 'layout.image-height',
  LAYOUT_SIDE_PADDING: 'layout.side-padding',
  BENEFITS_LAYOUT_WRAPPER: 'benefits-layout.wrapper',
  BENEFITS_LAYOUT_ALIGN_LEFT: 'benefits-layout.align-left',
  BENEFITS_LAYOUT_ALIGN_CENTER: 'benefits-layout.align-center',
  BENEFITS_LAYOUT_ALIGN_RIGHT: 'benefits-layout.align-right',
  BENEFITS_LAYOUT_ICON_POSITION: 'benefits-layout.icon-position',
  BENEFITS_LAYOUT_TOP_PADDING: 'benefits-layout.top-padding',
  BENEFITS_LAYOUT_BOTTOM_PADDING: 'benefits-layout.bottom-padding',
  BENEFITS_LAYOUT_ITEM_VERTICAL_PADDING: 'benefits-layout.item-vertical-padding',
  BENEFITS_LAYOUT_ICON_WRAPPER: 'benefits-layout.icon-wrapper',
  BENEFITS_LAYOUT_ICON_SPACING: 'benefits-layout.icon-spacing',
  BENEFITS_LAYOUT_ICON_SIZE: 'benefits-layout.icon-size',
  BENEFITS_LAYOUT_ICON_TOP_MARGIN: 'benefits-layout.icon-top-margin',
  BENEFITS_LAYOUT_ICON_ALIGN_TOP: 'benefits-layout.icon-align-top',
  BENEFITS_LAYOUT_ICON_ALIGN_CENTER: 'benefits-layout.icon-align-center',
  RIBBON_CHANGE_TEXT_WRAPPER: 'ribbon-change-text.wrapper',
  RIBBON_CHANGE_TEXT_INPUT: 'ribbon-change-text.input',
  RIBBON_LAYOUT_WRAPPER: 'ribbon-layout.wrapper',
  RIBBON_LAYOUT_VERTICAL_PADDING: 'ribbon-layout.vertical-padding',
  RIBBON_LAYOUT_HORIZONTAL_PADDING: 'ribbon-layout.horizontal-padding',
  PRICING_LAYOUT_WRAPPER: 'pricing-layout.wrapper',
  PRICING_LAYOUT_ALIGN_LEFT: 'pricing-layout.align-left',
  PRICING_LAYOUT_ALIGN_CENTER: 'pricing-layout.align-center',
  PRICING_LAYOUT_ALIGN_RIGHT: 'pricing-layout.align-right',
  PRICING_LAYOUT_CURRENCY_ALIGN_TOP: 'pricing-layout.currency-align-top',
  PRICING_LAYOUT_CURRENCY_ALIGN_CENTER: 'pricing-layout.currency-align-center',
  PRICING_LAYOUT_CURRENCY_ALIGN_BOTTOM: 'pricing-layout.currency-align-bottom',
  PRICING_LAYOUT_CURRENCY_MARGIN_INPUT: 'pricing-layout.currency-margin-input',
  PRICING_LAYOUT_CURRENCY_POSITION: 'pricing-layout.currency-position',
  PRICING_LAYOUT_CURRENCY_SPACING: 'pricing-layout.currency-spacing',
  PLAN_LIST_LAYOUT_VERTICAL_PADDING: 'plan-list.layout.vertical-padding',
  PLAN_LIST_LAYOUT_HORIZONTAL_PADDING: 'plan-list.layout.horizontal-padding',
  PLAN_LIST_LAYOUT_CARDS_VERTICAL_MARGINS: 'plan-list.layout.cards-vertical-margins',
  PLAN_LIST_LAYOUT_CARDS_HORIZONTAL_GAP: 'plan-list.layout.cards-horizontal-gap',
  PLAN_LIST_LAYOUT_CARDS_VERTICAL_GAP: 'plan-list.layout.cards-vertical-gap',
  PLAN_LIST_LAYOUT_CARDS_WIDTH: 'plan-list.layout.cards-width',
  PLAN_LIST_LAYOUT_HEADER_ALIGNMENT: 'plan-list.layout.header-alignment',
  PLAN_LIST_LAYOUT_HEADER_WIDTH: 'plan-list.layout.header-width',
  PLAN_LIST_LAYOUT_DISCLAIMER_ALIGNMENT: 'plan-list.layout.disclaimer-alignment',
  PLAN_LIST_LAYOUT_DISCLAIMER_WIDTH: 'plan-list.layout.disclaimer-width',
  PLAN_LIST_LAYOUT_TITLE_ALIGNMENT: 'plan-list.layout.title-alignment',
  PLAN_LIST_LAYOUT_TITLE_WIDTH: 'plan-list.layout.title-width',
  PLAN_LIST_LAYOUT_SUBTITLE_ALIGNMENT: 'plan-list.layout.subtitle-alignment',
  PLAN_LIST_LAYOUT_SUBTITLE_WIDTH: 'plan-list.layout.subtitle-width',
  ADDONS_MODAL: 'addons-modal',
  ADDONS_MODAL_PLAN_LIST: 'addons-modal.plan-list',
  ADDONS_MODAL_SINGLE_PLAN: 'addons-modal.single-plan',
  ADDONS_MODAL_PAGES_DROPDOWN: 'addons-modal.pages-dropdown',
  ADDONS_MODAL_PAGES_DROPDOWN_BUTTON: 'addons-modal.pages-dropdown.button',
  BLOCKS_WIDGET_SETTINGS_EMPTY: 'blocks-widget-settings.empty-state',
  BLOCKS_PLAN_LIST_SETTINGS_TABS: 'blocks-plan-list-settings.tabs',
  BLOCKS_PLAN_LIST_SETTINGS_PLAN_CHECKBOX: 'blocks-plan-list-settings.plan-checkbox',
  BLOCKS_PLAN_LIST_SETTINGS_REORDER_PLANS: 'blocks-plan-list-settings.reorder-plans',
  BLOCKS_PLAN_LIST_SETTINGS_REORDER_PLANS_MOVE_UP: 'blocks-plan-list-settings.reorder-plans-move-up',
  BLOCKS_PLAN_LIST_SETTINGS_REORDER_PLANS_MOVE_DOWN: 'blocks-plan-list-settings.reorder-plans-move-down',
  BLOCKS_PLAN_LIST_SETTINGS_REORDER_PLANS_MOVE_TO_START: 'blocks-plan-list-settings.reorder-plans-move-to-start',
  BLOCKS_PLAN_LIST_SETTINGS_REORDER_PLANS_MOVE_TO_END: 'blocks-plan-list-settings.reorder-plans-move-to-end',
  BLOCKS_PLAN_LIST_LAYOUT_PANEL: 'blocks-plan-list.layout-panel',
  BLOCKS_PLAN_LIST_LAYOUT_PANEL_LAYOUT_TYPE: 'blocks-plan-list.layout-panel.layout-type',
  BLOCKS_PLAN_LIST_LAYOUT_PANEL_BUTTON_POSITION: 'blocks-plan-list.layout-panel.button-position',
  BLOCKS_PLAN_LIST_ITEM_SETTINGS_VARIANT_RADIO_BUTTONS: 'blocks-plan-list-item-settings.variant.radio-buttons'
};
//# sourceMappingURL=editor.js.map